"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5 2.04825C11.7108 1.80038 10.871 1.66675 9.99996 1.66675C5.39759 1.66675 1.66663 5.39771 1.66663 10.0001C1.66663 14.6025 5.39759 18.3334 9.99996 18.3334C14.6023 18.3334 18.3333 14.6025 18.3333 10.0001C18.3333 8.57064 17.9734 7.22526 17.3393 6.04962M14.1666 4.79175H14.1708M8.75 18.2403L8.75009 16.4042C8.7501 16.3047 8.78568 16.2086 8.8504 16.133L10.9219 13.7163C11.0921 13.5176 11.0394 13.2131 10.8123 13.0833L8.43207 11.7232C8.3674 11.6862 8.31382 11.6326 8.27691 11.5679L6.72534 8.84894C6.64459 8.70743 6.48877 8.62597 6.32649 8.64042L1.72011 9.0507M17.5 5.00008C17.5 6.84103 15.8333 8.33341 14.1666 10.0001C12.5 8.33341 10.8333 6.84103 10.8333 5.00008C10.8333 3.15913 12.3257 1.66675 14.1666 1.66675C16.0076 1.66675 17.5 3.15913 17.5 5.00008ZM14.375 4.79175C14.375 4.90681 14.2817 5.00008 14.1666 5.00008C14.0516 5.00008 13.9583 4.90681 13.9583 4.79175C13.9583 4.67669 14.0516 4.58341 14.1666 4.58341C14.2817 4.58341 14.375 4.67669 14.375 4.79175Z",
    stroke: fill,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports["default"] = _default;